<script lang="ts" setup>
  // import GameTabPvP from '~/components/loggedOutNew/GameTabPvP.vue';
  // import GameTabSoloPlay from '~/components/loggedOutNew/GameTabSoloPlay.vue';

  defineEmits<{ click: [] }>();

  const ETabs = {
    PVP: 'PVP',
    SOLOPLAY: 'SOLOPLAY',
  } as const;
  type TTabs = (typeof ETabs)[keyof typeof ETabs];

  // const TAB_SUBTITLES = {
  //   [ETabs.PVP]: 'Cutting-edge PvP games in which players compete for the entire prize pot',
  //   [ETabs.SOLOPLAY]: 'Play quick rounds in single player versions of classic games',
  // };
  const TAB_BUTTONS = [
    {
      text: 'Player vs Player',
      icon: 'SvgoPvp',
      color: '#fff',
      value: ETabs.PVP,
    },
    {
      text: 'SoloPlay',
      icon: 'SvgoFtg',
      color: 'none',
      value: ETabs.SOLOPLAY,
    },
  ];

  const activeTab = ref<TTabs>(ETabs.PVP);
</script>

<template>
  <section id="lo-game-list" class="w-full flex flex-col gap-5 font-barlow text-white md:mx-auto">
    <!-- Tabs -->
    <div class="flex p-1.5 items-start gap-2.5 self-stretch rounded-md bg-white/5 w-full max-w-[44.75rem] mx-auto">
      <button
        v-for="tab in TAB_BUTTONS"
        :key="tab.value"
        class="flex px-2.5 py-[0.875rem] justify-center items-center gap-2 flex-1 rounded bg-white/2"
        :class="{
          'bg-white/20': activeTab === tab.value,
          'cursor-pointer': activeTab !== tab.value,
        }"
        @click="activeTab = tab.value"
      >
        <component
          :is="tab.icon"
          :color="tab.color"
          class="size-6 md:size-5 shrink-0 m-0"
          :class="{
            'opacity-50': activeTab !== tab.value,
          }"
        />
        <span
          class="font-inter max-xxs:text-[13px] text-sm not-italic font-medium leading-none"
          :class="{
            'text-white': activeTab === tab.value,
            'text-white/50': activeTab !== tab.value,
          }"
        >
          {{ tab.text }}
        </span>
      </button>
    </div>

    <!--
    <p class="text-base not-italic font-medium leading-[130%] px-4">
      {{ TAB_SUBTITLES[activeTab] }}
    </p>
    -->

    <!--    <GameTabPvP v-if="activeTab === ETabs.PVP" @click="$emit('click')" /> -->
    <!--    <GameTabSoloPlay v-else @click="$emit('click')" /> -->
    <LazyLoggedOutNewGameTabPvP v-if="activeTab === ETabs.PVP" @click="$emit('click')" />
    <LazyLoggedOutNewGameTabSoloPlay v-else @click="$emit('click')" />
  </section>
</template>
